module.exports = __webpack_public_path__ + "img/img_2.afa4f05.png";


//////////////////
// WEBPACK FOOTER
// ./static/mobileb/img_2.png
// module id = Tbtu
// module chunks = 1